import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    container: 'flex items-center gap-2.5',
    value: 'sm:heading-3xl-desk heading-3xl mb-1 leading-none',
    starsContainer: 'gap-2',
    star: 'size-8'
  }
});
